module.exports = __webpack_public_path__ + "img/Cupcat-1.33a04e3e.gif";